'use client';

import Image from 'next/image';

import type { TDynamicData } from '@eliadmin/core/src/api/dynamics/dynamics-api';

import { fetchDynamicSectionsById } from '@eliadmin/core/src/api/dynamics/dynamics-api';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';
import { useQuery } from '@tanstack/react-query';
import { MdOutlineLock } from 'react-icons/md';

import { Paragraph } from '../../ui/paragraph';

/** Eliadmin → Webstránky → Dynamické sekcie → "Platobné metódy". */
const PAYMENT_METHODS_SECTION_ID = 6;

/** Field ids of the "Platobné metódy" section, as defined in Eliadmin. */
const FIELD = {
  logo: 15, // Logo
} as const;

/** Payment logos (one per active "Platobné metódy" entry, in admin order) and the secure-purchase note. */
export function ProductPaymentMethods() {
  const { t } = useTranslations();
  const locale = useLocaleStore(state => state.currentLocale);

  const { data: methods = [] } = useQuery({
    queryKey: ['PAYMENT_METHODS', locale],
    queryFn: () =>
      fetchDynamicSectionsById<TDynamicData>({ locale, id: PAYMENT_METHODS_SECTION_ID }),
  });

  return (
    <div className="hidden w-full flex-wrap items-center justify-start gap-2 sm:flex">
      <div className="flex items-center justify-center gap-2">
        {methods.map(method => {
          const logo = method.fields.find(entry => entry.field.id === FIELD.logo)?.image;
          if (!logo?.url) return null;

          return (
            <Image
              key={method.id}
              src={logo.url}
              alt={resolveImageAlt(logo, method.name)}
              width={54}
              height={28}
              className="shrink-0 object-contain object-center"
            />
          );
        })}
      </div>
      <div className="flex items-center justify-center gap-2">
        <MdOutlineLock size={20} className="text-[#666666]" />
        <Paragraph size="base" color="muted-foreground">
          {t('text3677')}
        </Paragraph>
      </div>
    </div>
  );
}
